import React from 'react';
import './Home.css'

const Banner = () => {
    return (
        <div className='relative'>
            <div className='hero h-screen bg-accent relative'>
                <div className='hero-content flex-col lg:flex-row lg:mt-[-100px] lg:mb-20 lg:w-10/12'>
                    <div data-aos="fade-left" data-aos-delay='600' data-aos-duration='800' className='lg:w-3/6 shrink-0 flex justify-center items-center md:order-last'>
                        <img src="https://techmende.com/wp-content/uploads/2022/02/camera_lens-1.jpg" className='rounded-lg' alt='' />
                    </div>
                    <div className='mt-10 lg:mt-0'>
                        <h1
                            data-aos='fade-right'
                            data-aos-delay='400'
                            data-aos-duration='900'
                            className='md:text-6xl text-4xl font-bold leading-relaxed'
                        >
                            We are providing Professional <span className='text-primary'>Lenses</span>
                        </h1>
                        <p
                            data-aos='fade-right'
                            data-aos-delay='600'
                            data-aos-duration='800'
                            className='py-6 max-w-xl leading-relaxed'
                        >
                            All Lens and Tools that Needed the Most for your business. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra
                        </p>
                        <button
                            data-aos='zoom-in'
                            data-aos-delay='1300'
                            className='btn btn-primary'
                        >
                            Get Started
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;